<template>
  <div>
    <div class="card card-body mb-4">
      <v-search-field
        @search="filterObjects"
        @reset="reset"
      />
    </div>

    <div class="row" v-if="objectList.length > 0">
      <div
        class="col-md-6"
        :key="object.slug"
        v-for="object in objectList"
      >
        <v-organisation-card
          :organisation="object"
        />
      </div>
    </div>
    <div v-else-if="!loading" class="text-center text-danger">
      {{ $t('phrase.no_organisations_found') }}
    </div>

    <div class="d-flex justify-content-center mb-5" v-if="nextPageUrl">
      <v-button
        text="phrase.load_more"
        @click="getObjects(nextPageUrl, true)"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import OrganisationCard from '@/reviewer/components/OrganisationCard.vue';
import SearchField from '@/common/components/SearchField.vue';
import { GenericListMixin } from '@/common/utils/mixins';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';

export default {
  name: 'OrganisationList',
  components: {
    'v-button': Button,
    'v-organisation-card': OrganisationCard,
    'v-search-field': SearchField,
  },
  mixins: [
    GenericListMixin,
  ],
  data() {
    return {
      apiPath: 'public/organisations/',
      orgType: null,
    };
  },
  methods: {
    getParams() {
      let orgType = 'default';
      if (this.$route.query.type) {
        orgType = 'media_agency';
      }
      return { type: orgType };
    },
  },
  created() {
    setBreadcrumbs('organisationList', [this.$route.query.type]);
  },
};
</script>
